import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzNdd80 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_NDD_80: Record<
  Exclude<PageIdWoofzNdd80, PageIdWoofzNdd80.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_NDD_80]: {
    id: PageId.SUBSCRIPTIONS_NDD_80,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_NDD_80]: {
    id: PageId.CHAT_UPSELL_NDD_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_NDD_80]: {
    id: PageId.UPSELL_NDD_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_NDD_80]: {
    id: PageId.DOWNLOAD_NDD_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
